import { styled } from '@mui/material';

export const ContentWrap = styled('div')({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 100,
  height: '100vh',
});

export const Content = styled('div')({
  flex: 1,
  position: 'relative',
  maxWidth: 710,
  marginTop: -100,
});

export const ContractImage = styled('img')({
  position: 'absolute',
  width: 140,
  height: 124,
  left: 80,
  top: -133,
});

export const OrderImage = styled('img')({
  position: 'absolute',
  width: 100,
  height: 117,
  left: -40,
  top: 90,
});

export const SupplierImage = styled('img')({
  position: 'absolute',
  width: 169,
  height: 145,
  top: -145,
  right: 50,
});
